import { RequestAccessGlobalWorkflowState } from '../contexts/RequestAccessGlobalWorkflowContext';

export const getPopsIdentifierOnGlobalContext = (
  context: Readonly<RequestAccessGlobalWorkflowState>,
): string => {
  return (
    context.site?.popsIdentifier || context.widgetProps?.popsIdentifier || ''
  );
};
